module.exports = __webpack_public_path__ + "img/civic21.52d267de.png";